import { A as C, L as H, R as T, r as b } from "./authRefresh-BJvnKMdt.js";
function o() {
  return typeof window > "u" ? null : window.newrelic ?? null;
}
function i() {
  return "";
}
function u() {
  return o();
}
function s(e, n) {
  var t, r;
  (r = (t = o()) == null ? void 0 : t.setCustomAttribute) == null || r.call(t, e, n);
}
function c(e, n) {
  var t, r;
  (r = (t = o()) == null ? void 0 : t.setPageViewName) == null || r.call(t, n);
}
function a(e, n) {
  var t, r;
  (r = (t = o()) == null ? void 0 : t.addPageAction) == null || r.call(t, e, n);
}
function f(e, n) {
}
function l(e, n) {
  var t, r;
  try {
    (r = (t = o()) == null ? void 0 : t.noticeError) == null || r.call(t, e, n);
  } catch {
  }
}
function E(e, n, t) {
}
function _(e, n) {
  return n;
}
function d() {
  return u() !== null;
}
function m(e) {
  return null;
}
function p(e) {
}
function R(e, n, t) {
  return n;
}
function A(e, n) {
  return e;
}
function N() {
  return !1;
}
function w(e) {
  return null;
}
export {
  C as AUTH_REFRESH_EVENT,
  H as LIGONIER_CLIENT_HEADER,
  w as NewRelicClientScript,
  T as REFRESH_OUTCOME_HEADER,
  a as addPageAction,
  m as authRefreshEvent,
  i as getAppName,
  u as getNewRelic,
  N as installProcessErrorHandlers,
  _ as instrumentLoader,
  A as instrumentSdk,
  R as instrumentSdkMethod,
  d as isNewRelicAvailable,
  l as noticeError,
  E as noticeRequestError,
  p as recordAuthRefresh,
  f as recordCustomEvent,
  b as rotatedFromOutcome,
  s as setCustomAttribute,
  c as setTransactionName
};
